<template>
<v-dialog
  :value="true"
  persistent
  max-width="1100"
  :content-class="'newsItemModal'"
>
  <v-card outlined class="newsItemModal__card px-6 py-4">
    <div class="newsItemModal__close d-flex justify-end">
      <v-btn
        small
        @click="closeModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="newsItemModal__title">
      {{modal.title}}
    </div>
    <div class="newsItemModal__body">
      <div class="text">
        <span v-html="modal.text" class="text-pre-wrap pb-4"/>
        <div class="btn_block d-flex flex-column gap-3" >
          <v-btn
            large
            color="white"
            outlined
            @click="goToTgBot"
          >
            Перейти в Телеграм бот
          </v-btn>
          <v-btn
            large
            color="white"
            outlined
            @click="goToTelegram"
          >
            Связаться с менеджером
          </v-btn>
        </div>

      </div>
      <div class="image">
        <v-img
        :contain="true"
        aspect-ratio="1.5"
        :src="modal.image_url"
        />
      </div>
    </div>
  </v-card>
</v-dialog>
</template>

<script>

/**
 * Компонент: newsItemModal
 * Описание:
 */
export default {
  name: 'newsItemModal',

  components: { },

  props: {
    modal: {
      type: Object,
      default: () => {}
    },
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    goToTelegram() {
      window.open('https://t.me/Team_Assessment', '_blank');
    },
    goToTgBot() {
      window.open('https://t.me/TeamlineHR_bot', '_blank');
    }
  },
};
</script>

<style scoped lang="scss">
.newsItemModal {
  background: white;
  box-shadow: none;
  /* Стили компонента */
  &__card{
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-shadow: none;

  }
  &__title{
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    padding: 8px 0;
    color: var(--color-blue-500);
  }
  &__body{
    display: flex;
    justify-content: space-between;
    gap: 24px;
    & .text{
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      max-width: 340px;
      gap: 16px;

      & span{
        display: inline-block;
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: black;
      }
      & .btn_block{
        display: flex;
        flex-direction: column;
        & .v-btn{
          background: var(--color-blue-500);
          border-radius: 6px;
          height: 100%;
          font-size: 16px;
          padding: 16px 16px;
          font-weight: 600;
          max-height: 52px;
          ::v-deep span{
            line-height: 24px;
          }
          &.background_transparent{
            background: transparent;
            color: var(--color-blue-500)!important;
          }
        }

      }
    }
    & .image{
      flex-grow: 1;
    }
  }

}
</style>
